import React from 'react';
import { Link } from 'react-router-dom';

const ShopPage: React.FC = () => {
  const products = [
    {
      id: 1,
      name: "Custom Tailored Suit",
      price: "$299",
      description: "Premium wool suit with custom measurements",
      image: "👔"
    },
    {
      id: 2,
      name: "Designer Dress",
      price: "$199",
      description: "Elegant dress with perfect fit",
      image: "👗"
    },
    {
      id: 3,
      name: "Business Shirt",
      price: "$89",
      description: "Professional shirt with custom fit",
      image: "👕"
    },
    {
      id: 4,
      name: "Formal Pants",
      price: "$129",
      description: "Classic pants with tailored fit",
      image: "👖"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Tailored Collection</h1>
          <p className="text-xl text-gray-600">Discover our premium custom-tailored clothing</p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="text-4xl mb-4 text-center">{product.image}</div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{product.name}</h3>
                <p className="text-gray-600 mb-4">{product.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-blue-600">{product.price}</span>
                  <Link
                    to="/get-measured"
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    Get Measured
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Ready for Perfect Fit?</h2>
            <p className="text-lg text-gray-600 mb-6">
              Get your measurements taken and order your custom-tailored clothing today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/get-measured"
                className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors text-lg font-semibold"
              >
                Start Measuring
              </Link>
              <Link
                to="/track-order"
                className="bg-gray-600 text-white px-8 py-3 rounded-lg hover:bg-gray-700 transition-colors text-lg font-semibold"
              >
                Track Order
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopPage; 